/** @deprecated */
export var pauseAlt = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"18\" viewBox=\"0 0 14 18\"><path class=\"a\" d=\"M0 0h5v18H0zm9 0h5v18H9z\"/></svg>";